import { Link } from "react-router-dom";
import { ShieldAlert, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { can, ROLE_LABELS } from "@/lib/permissions";

export function PermGate({ action, title, children }) {
  const { user } = useAuth();
  const role = user?.role || "intake_staff";
  if (can(role, action)) return children;
  return (
    <div className="max-w-2xl mx-auto mt-16 border border-zinc-200 bg-white p-12 text-center" data-testid="perm-gate">
      <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#0B1F33] text-white mb-6">
        <ShieldAlert className="h-6 w-6" strokeWidth={1.8} />
      </div>
      <p className="font-mono-data text-xs uppercase tracking-[0.2em] text-[#B54747]">Restricted</p>
      <h1 className="font-display text-4xl font-light mt-2">{title || "You don't have access"}</h1>
      <p className="text-zinc-500 mt-3">
        Your role (<span className="font-medium">{ROLE_LABELS[role]}</span>) doesn't have permission to view this page.
        Ask an Owner if you need access.
      </p>
      <Button asChild variant="outline" className="mt-8 rounded-none h-11 px-6 border-zinc-300 group" data-testid="perm-gate-back">
        <Link to="/app">
          Back to overview
          <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </Button>
    </div>
  );
}

export default PermGate;
